import {Configuration, ExternalSystemsApi, Middleware, TasksApi, TopicsProjectsApi} from "@dain/tracker-client";
import {TrackerConfigDto} from "../../../../../configuration/TrackerConfigDto";
import {KeycloakHolder} from "../../../../../keycloak/KeycloakHolder";

export default class TrackerService {
    private readonly tasksApi: TasksApi;
    private readonly topicsProjectsApi: TopicsProjectsApi;
    private readonly extSystemsApi: ExternalSystemsApi

    constructor(private readonly trackerConfig: TrackerConfigDto) {
        const keycloakBearerTokenInterceptor: Middleware = {
            async pre(context) {
                const keycloak = KeycloakHolder.keycloak;
                if (keycloak) {
                    try {
                        await keycloak.updateToken(10);
                    } catch (e) {
                        console.warn("Failed to refresh Keycloak token, proceeding with current token", e);
                    }
                }
                const token = KeycloakHolder.getToken();
                if (token) {
                    context.init.headers = {
                        ...context.init.headers,
                        "Authorization": `Bearer ${token}`,
                        "ClientRegistrationId": trackerConfig.clientRegistrationId ?? "",
                    };
                } else {
                    console.warn("No Keycloak token available, tracker request will be sent without authorization");
                }
                return {url: context.url, init: context.init};
            }
        };

        const configuration = new Configuration({
            basePath: trackerConfig.baseUrl,
            middleware: [keycloakBearerTokenInterceptor],
        });
        this.tasksApi = new TasksApi(configuration);
        this.topicsProjectsApi = new TopicsProjectsApi(configuration);
        this.extSystemsApi = new ExternalSystemsApi(configuration);
    }

    get api(): TasksApi {
        return this.tasksApi;
    }

    get topicsApi(): TopicsProjectsApi {
        return this.topicsProjectsApi;
    }

    get externalSystemsApi(): ExternalSystemsApi {
        return this.extSystemsApi;
    }

    public getTaskUrl(taskKey: string): string {
        return (this.trackerConfig.taskUrl ?? "").replace("{{taskKey}}", taskKey);
    }
}
